function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatBytes } from '@/libs/public';
import { folderSpaceEntDeleteApi, folderSpaceEntRenameApi, folderSpaceEntViewApi, folderRecentlyListApi } from '@/api/cloud';
import file from '@/utils/file';
Vue.use(file);
import Vue from 'vue';
export default {
  name: 'SpaceFile',
  components: {
    imageViewer: function imageViewer() {
      return import('@/components/common/imageViewer');
    },
    moveDialog: function moveDialog() {
      return import('../moveDialog');
    },
    fileAttribute: function fileAttribute() {
      return import('../fileAttribute');
    },
    ElImageViewer: function ElImageViewer() {
      return import('element-ui/packages/image/src/image-viewer');
    },
    rightClick: function rightClick() {
      return import('../rightClick');
    },
    defaultPage: function defaultPage() {
      return import('@/components/common/defaultPage');
    },
    authorDialog: function authorDialog() {
      return import('../authorDialog');
    },
    oaDialog: function oaDialog() {
      return import('@/components/form-common/dialog-form');
    }
  },
  props: {
    fileStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    switch: {
      type: Number,
      default: 4
    },
    spaceId: {
      type: Number | String,
      default: 0
    },
    pageLimit: {
      type: Number,
      default: 0
    },
    wps_type: {
      type: String | Number,
      default: '0'
    },
    spaceType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      checked: false,
      fileData: [],
      activeValue: '',
      renameIndex: null,
      renameName: '',
      where: {
        page: 1,
        limit: this.pageLimit,
        pid: '',
        is_del: 0
      },
      total: 0,
      breadcrumbArray: [{
        name: this.$t('file.allfiles'),
        pid: ''
      }],
      id: 0,
      isImage: false,
      srcList: [],
      formBoxConfig: {},
      menuIds: [],
      handleData: {
        id: 0,
        ids: []
      },
      moveData: {
        id: 0,
        type: 3
      },
      rightData: {
        type: 6,
        data: {}
      },
      rightClickIndex: -1,
      fromData: {},
      pageHeight: 0,
      prevHeight: 0
    };
  },
  mounted: function mounted() {},
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    },
    pageLimit: function pageLimit(val) {
      this.where.limit = val;
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.breadcrumbArray[0].name = this.$t('file.allfiles');
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getTreeData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.getTreeData();
    },
    formatBytesFn: function formatBytesFn(size) {
      if (size) {
        size = Number(size);
        return formatBytes(size);
      } else {
        return '--';
      }
    },
    //获取数据
    getTreeData: function getTreeData(val) {
      var _this = this;
      if (val == 1) {
        this.where.page = val;
      }
      var data = {
        page: this.where.page,
        limit: this.pageLimit,
        pid: this.where.pid,
        file_type: this.fileTypeName(this.fileStyle.type),
        keyword: this.fileStyle.keyword,
        is_del: this.where.is_del
      };
      folderRecentlyListApi(data).then(function (res) {
        _this.fileData = res.data.list;
        _this.total = res.data.count;
        _this.$emit('totalFn', _this.total);
      });
    },
    // 查看与下载附件
    lookViewer: function lookViewer(item) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.isImage = true;
              url = item.file_url;
              if (_this2.fileData.length > 0) {
                _this2.fileData.map(function (value, index) {
                  if (value === url) {
                    _this2.fileData.splice(index, 1);
                  }
                });
                _this2.srcList.unshift(url);
              }
              _this2.$refs.imageViewer.openImageViewer(url);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 分享云文件
    shareOther: function shareOther(item) {
      this.$emit('shareItemFile', item);
    },
    // 点击item项
    getItemFile: function getItemFile(item) {
      if (item.type == 1) {
        this.where.pid = item.id;
        this.where.is_shortcut = 0;
        if (this.breadcrumbArray.findIndex(function (n) {
          return n.pid === item.id;
        }) < 0) {
          this.breadcrumbArray.push({
            name: item.name,
            pid: item.id
          });
          this.getTreeData(1);
          this.handlerEmit({
            name: item.name,
            pid: item.id
          });
        }
      } else {
        this.$emit('openItemFile', item);
      }
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
    },
    // 点击面包屑
    getBreadcrumb: function getBreadcrumb(id, index) {
      if (id != this.where.pid) {
        if (this.switch === 5 && id == '') {
          this.where.is_shortcut = 1;
        }
        this.where.page = 1;
        this.where.pid = id;
        this.getTreeData();
      }
    },
    handlerEmit: function handlerEmit(item) {
      this.handleData.id = this.where.pid === '' ? 0 : this.where.pid;
      this.handleData.ids = this.menuIds;
      this.$emit('handlerMyFile', this.handleData, item);
    },
    handleShow: function handleShow(index) {
      this.activeValue = index;
    },
    checkChange: function checkChange(type) {
      var _this3 = this;
      if (type === 1) {
        if (this.fileData && this.fileData.length > 0) {
          this.fileData.map(function (item) {
            if (_this3.menuIds.findIndex(function (n) {
              return n === item.id;
            }) < 0) {
              _this3.checked = true;
              _this3.menuIds.push(item.id);
            } else {
              _this3.checked = false;
              if (_this3.menuIds.findIndex(function (n) {
                return n == item.id;
              }) > -1) {
                _this3.menuIds.splice(_this3.menuIds.findIndex(function (n) {
                  return n == item.id;
                }), 1);
              }
            }
          });
        }
      } else {
        if (this.menuIds.length === 1 && this.menuIds[0] === 0) {
          this.checked = false;
          this.menuIds = [];
        }
      }
      this.handlerEmit();
    },
    itemCheckChange: function itemCheckChange(row) {
      if (this.fileStyle.style === 1) return false;
      if (this.menuIds.includes(row.id)) {
        this.menuIds.splice(this.menuIds.findIndex(function (n) {
          return n === row.id;
        }), 1);
      } else {
        this.menuIds.push(row.id);
      }
      this.handlerEmit();
    },
    addAuthor: function addAuthor(row) {
      this.fromData = {
        title: this.$t('file.setdirectory'),
        fid: this.spaceId,
        id: row.id,
        edit: 1
      };
      this.$refs.authorDialog.handleOpen();
    },
    // 浏览文件
    handleSeeFil: function handleSeeFil(item) {
      var _this4 = this;
      folderSpaceEntViewApi(item.pid, item.id).then(function (res) {
        if (!res.data.url) return _this4.$message.error('您暂时没有权限查看此文件');
        window.open(res.data.url, '_blank');
      });
    },
    getStartCollect: function getStartCollect(item) {
      this.getCollect(item);
      this.closePopover();
    },
    // 删除
    getFolderDelete: function getFolderDelete(item) {
      var _this5 = this;
      this.$modalSure('你确定要删除该内容吗').then(function () {
        var spaceId = _this5.spaceType == 'recently' ? item.pid : _this5.spaceId;
        folderSpaceEntDeleteApi(spaceId, item.id).then(function (res) {
          if (_this5.where.page > 1 && _this5.fileData.length <= 1) {
            _this5.where.page--;
          }
          _this5.getTreeData();
          _this5.closePopover();
        });
      });
    },
    // 重命名
    setRenameItem: function setRenameItem(item, index) {
      this.renameIndex = index;
      this.renameName = item.name;
      this.closePopover();
      this.$nextTick(function () {
        document.getElementById('input' + index).focus();
      });
    },
    // 失去焦点
    renameBlur: function renameBlur(item) {
      this.renameIndex = null;
      if (item.name === '') {
        item.name = this.renameName;
        return false;
      }
      if (this.renameName !== this.trim(item.name)) {
        this.getFolderRename(item, {
          name: item.name
        });
      }
    },
    // 重命名
    getFolderRename: function getFolderRename(item, data) {
      var _this6 = this;
      var id = this.spaceType == 'recently' ? item.pid : this.spaceId;
      folderSpaceEntRenameApi(id, item.id, data).then(function (res) {
        _this6.getTreeData();
      }).catch(function (error) {
        _this6.getTreeData();
      });
    },
    getFileAttribute: function getFileAttribute(item) {
      this.formBoxConfig = {
        title: this.$t('file.fileattribute'),
        is_file: false,
        fid: item.pid,
        id: item.id,
        width: '450px'
      };
      this.$refs.fileAttribute.openBox();
    },
    // 移动或复制
    getMoveDialog: function getMoveDialog(item, type) {
      if (type === 1) {
        this.moveData.type = 3;
      } else {
        this.moveData.type = 6;
      }
      this.moveData.id = item.id;
      this.moveData.fid = item.pid;
      this.$refs.moveDialog.handleOpen();
    },
    // 移动回调
    handlerMove: function handlerMove(data) {
      if (data.type === 3 || data.type === 6) {
        this.getTreeData();
      }
    },
    closePopover: function closePopover() {
      if (this.rightClickIndex > -1) {
        this.rightClickIndex = -1;
      } else {
        this.$refs["pop-".concat(this.activeValue)][0].doClose();
      }
    },
    rightClick: function rightClick(event, item, index) {
      this.rightData.data = item;
      this.rightClickIndex = index;
      this.$refs.rightClick.menuVisible = true;
      this.$refs.rightClick.rightClick(event);
    },
    // 右键
    handleRightClick: function handleRightClick(data) {
      if (data.index === 2) {
        // 移动
        this.getMoveDialog(data.row, 1);
      } else if (data.index === 3) {
        // 复制
        this.getMoveDialog(data.row, 2);
      } else if (data.index === 4) {
        // 重命名
        this.setRenameItem(data.row, this.rightClickIndex);
      } else if (data.index === 5) {
        // 属性
        this.getFileAttribute(data.row);
      } else if (data.index === 6) {
        // 删除
        this.getFolderDelete(data.row);
      } else if (data.index === 9) {
        // 设置权限
        this.addAuthor(data.row);
      } else if (data.index == 10) {
        // 分享
        this.shareOther(data.row);
      }
    },
    isOk: function isOk() {
      this.getTreeData();
    }
  }
};